function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "car"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M19,18H13a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M19,21H13a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M29,20H24.34A2.34,2.34,0,0,0,22,22.34V24H10V22.34A2.34,2.34,0,0,0,7.66,20H4V18.1A1.1,1.1,0,0,1,5.1,17H26.9a1.1,1.1,0,0,1,.94.52,1,1,0,1,0,1.7-1A3.12,3.12,0,0,0,29,15.8s0,0,0-.06L26.53,6.8A3.81,3.81,0,0,0,22.86,4H9.14A3.81,3.81,0,0,0,5.47,6.8L4.13,11.74A1,1,0,0,0,4.83,13a1,1,0,0,0,1.23-.7L7.4,7.32A1.81,1.81,0,0,1,9.14,6H22.86A1.81,1.81,0,0,1,24.6,7.32L26.69,15H25a4,4,0,0,0-8,0H5.1A3.1,3.1,0,0,0,2,18.1v4.8A3.09,3.09,0,0,0,5,26v.51a3.5,3.5,0,0,0,7,0V26h8v.5a3.5,3.5,0,0,0,7,0V26a3.09,3.09,0,0,0,3-3.09V21A1,1,0,0,0,29,20Zm-8-7a2,2,0,0,1,2,2H19A2,2,0,0,1,21,13Zm3,9.34a.34.34,0,0,1,.34-.34H28v.52A1.48,1.48,0,0,1,26.52,24H24ZM7.66,22a.34.34,0,0,1,.34.34V24H5.48A1.48,1.48,0,0,1,4,22.52V22ZM10,26.5a1.5,1.5,0,0,1-3,0V26h3ZM23.5,28A1.5,1.5,0,0,1,22,26.5V26h3v.5A1.5,1.5,0,0,1,23.5,28Z"
}));

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.fc86c818.svg";
export { ForwardRef as ReactComponent };